import { lazy } from 'react'
import { ClipboardCheck } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Onboarding = lazy(() => import('./pages/Onboarding').then((m) => ({ default: m.Onboarding })))

export const onboardingRoutes: FeatureRoute[] = [
  { path: 'onboarding', element: <Onboarding /> },
]

// Onboarding contains operational handoff data, so keep its navigation limited
// to admins (matching the onboarding.view permission granted to that role).
export const onboardingNav: NavItem[] = [
  { to: '/onboarding', label: 'Onboarding', icon: ClipboardCheck, section: 'Sales', adminOnly: true },
]
